import { type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../styles.constants';

export const backButton: CSSProperties = {
  cursor: 'pointer',
  textAlign: 'start',
  color: StyleConstants.GREY_COLOR,
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
};

export const backArrow: CSSProperties = {
  color: StyleConstants.GREY_COLOR,
};
